import gql from "graphql-tag";

export default gql`query SearchGeneral($value:String!) {
    searchGeneral(value:$value)
  }`